/* Uncertified 2026 sections: colorway ring, reviews carousel, quick add, the Boxy Blank product page and the
   email + SMS signup popup (Klaviyo). Adds go through Shopify's cart API, then the theme's own cart drawer
   refreshes and opens (window.refreshCart from component-cart.js). */
(() => {
  if (window.__ucLoaded) return;   // the script tag can appear more than once on a page
  window.__ucLoaded = true;
  const reduce = matchMedia("(prefers-reduced-motion: reduce)").matches;
  const mod = (n, m) => ((n % m) + m) % m;
  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || "/";

  /* ---------- cart ---------- */
  async function addToCart(items) {
    const res = await fetch(`${root}cart/add.js`, {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ items }),
    });
    const data = await res.json().catch(() => ({}));
    if (!res.ok) throw new Error(data.description || data.message || "That couldn't be added to your bag.");
    if (typeof window.refreshCart === "function") window.refreshCart();
    else location.href = `${root}cart`;
    return data;
  }

  function toast(msg) {
    const t = document.createElement("div");
    t.className = "uc uc-toast";
    t.setAttribute("role", "status");
    t.textContent = msg;
    t.style.cssText = "position:fixed;left:50%;bottom:24px;transform:translateX(-50%);z-index:10000;background:#111;color:#fff;padding:12px 18px;font:400 12px/1.4 'Helvetica Neue',Helvetica,Arial,sans-serif;max-width:calc(100vw - 32px)";
    document.body.appendChild(t);
    setTimeout(() => t.remove(), 3200);
  }

  // Quick add buttons on product tiles: <button data-uc-add="VARIANT_ID">
  document.addEventListener("click", async e => {
    const b = e.target.closest("[data-uc-add]");
    if (!b) return;
    e.preventDefault();
    b.disabled = true;
    try { await addToCart([{ id: +b.dataset.ucAdd, quantity: 1 }]); }
    catch (err) { toast(err.message); }
    finally { b.disabled = false; }
  });

  /* ---------- hero: ring of colorway cards ---------- */
  function initRing(sec) {
    const ring = sec.querySelector("[data-uc-ring-el]");
    if (!ring || ring.dataset.ready) return;
    ring.dataset.ready = "1";
    const cards = [...ring.children];
    const N = cards.length;
    if (!N) return;
    const STEP = 360 / N, HOLD = +sec.dataset.hold || 3600, suffix = sec.dataset.suffix || "";
    ring.style.setProperty("--step", `${STEP}deg`);
    cards.forEach((c, i) => c.style.setProperty("--i", i));
    const title = sec.querySelector("[data-uc-hero-color]");
    const capTitle = sec.querySelector("[data-uc-cap-title]");
    const capShop = sec.querySelector("[data-uc-cap-shop]");
    const pauseBtn = sec.querySelector("[data-uc-pause]");
    let angle = 0, front = 0, playing = !reduce, timer = null, hovering = false;

    function setFront(f) {
      const changed = f !== front;
      front = f;
      cards.forEach((c, i) => {
        c.classList.toggle("is-front", i === f);
        const pill = c.querySelector(".uc-pill");
        if (pill) pill.tabIndex = i === f ? 0 : -1;
      });
      const name = cards[f].dataset.name, url = cards[f].dataset.url;
      if (capTitle) capTitle.textContent = `${name} ${suffix}`.trim();
      if (capShop && url) capShop.href = url;
      if (!title || title.textContent === name) return;
      if (!changed || reduce || !title.animate) { title.textContent = name; return; }
      title.animate([{ opacity: 1, transform: "translateY(0)", filter: "blur(0)" }, { opacity: 0, transform: "translateY(-.12em)", filter: "blur(6px)" }],
        { duration: 260, delay: 240, easing: "ease-in", fill: "forwards" }).onfinish = ev => {
          title.textContent = name;
          ev.target.cancel();
          title.animate([{ opacity: 0, transform: "translateY(.12em)", filter: "blur(6px)" }, { opacity: 1, transform: "translateY(0)", filter: "blur(0)" }],
            { duration: 520, easing: "cubic-bezier(.16,1,.3,1)" });
        };
    }
    function setAngle(a, animate = true) {
      angle = a;
      ring.classList.toggle("is-dragging", !animate);
      ring.style.setProperty("--a", `${angle}deg`);
      const f = mod(Math.round(-angle / STEP), N);
      if (f !== front || !animate) setFront(f);
    }
    const step = dir => setAngle(Math.round(angle / STEP) * STEP - dir * STEP);
    function schedule() {
      clearTimeout(timer);
      if (playing && !hovering && !document.hidden) timer = setTimeout(() => { step(1); schedule(); }, HOLD);
    }
    function setPlaying(p) {
      playing = p;
      if (pauseBtn) {
        pauseBtn.setAttribute("aria-label", p ? "Pause rotation" : "Play rotation");
        pauseBtn.innerHTML = p
          ? '<svg viewBox="0 0 16 16" fill="currentColor"><rect x="4" y="3" width="2.4" height="10"/><rect x="9.6" y="3" width="2.4" height="10"/></svg>'
          : '<svg viewBox="0 0 16 16" fill="currentColor"><path d="M4.5 3v10l8-5z"/></svg>';
      }
      schedule();
    }
    sec.querySelector("[data-uc-next]")?.addEventListener("click", () => { step(1); schedule(); });
    sec.querySelector("[data-uc-prev]")?.addEventListener("click", () => { step(-1); schedule(); });
    pauseBtn?.addEventListener("click", () => setPlaying(!playing));
    document.addEventListener("visibilitychange", schedule);

    // Drag or swipe to spin; a click on a side card brings it to the front.
    const wheel = sec.querySelector("[data-uc-wheel]");
    let drag = null;
    wheel.addEventListener("pointerdown", e => {
      if (e.target.closest(".uc-pill")) return;
      drag = { x: e.clientX, a: angle, moved: false, card: e.target.closest(".uc-card") };
      wheel.setPointerCapture(e.pointerId);
    });
    wheel.addEventListener("pointermove", e => {
      if (!drag) return;
      const dx = e.clientX - drag.x;
      if (Math.abs(dx) > 4) { drag.moved = true; wheel.classList.add("is-grabbing"); }
      if (drag.moved) setAngle(drag.a + dx * (STEP / (cards[0].offsetWidth * 0.9)), false);
    });
    const endDrag = () => {
      if (!drag) return;
      wheel.classList.remove("is-grabbing");
      if (drag.moved) setAngle(Math.round(angle / STEP) * STEP);
      else if (drag.card) {
        const i = cards.indexOf(drag.card);
        if (i !== front) { let d = mod(i - front, N); if (d > N / 2) d -= N; setAngle(Math.round(angle / STEP) * STEP - d * STEP); }
      }
      drag = null; schedule();
    };
    wheel.addEventListener("pointerup", endDrag);
    wheel.addEventListener("pointercancel", endDrag);

    // Gentle tilt toward the cursor; pause while the visitor is looking at the ring.
    const tilt = sec.querySelector("[data-uc-tilt]");
    if (!reduce && tilt) sec.addEventListener("pointermove", e => {
      if (e.pointerType !== "mouse") return;
      const r = sec.getBoundingClientRect();
      const x = (e.clientX - r.left) / r.width - .5, y = (e.clientY - r.top) / r.height - .5;
      tilt.style.transform = `rotateX(${(-y * 5).toFixed(2)}deg) rotateY(${(x * 7).toFixed(2)}deg)`;
    });
    sec.addEventListener("pointerleave", () => { if (tilt) tilt.style.transform = ""; });
    wheel.addEventListener("pointerenter", e => { if (e.pointerType === "mouse") { hovering = true; schedule(); } });
    wheel.addEventListener("pointerleave", () => { hovering = false; schedule(); });
    document.addEventListener("uc:modal", e => { hovering = e.detail; schedule(); });

    setAngle(0, false);
    requestAnimationFrame(() => ring.classList.remove("is-dragging"));
    setPlaying(playing);
  }

  /* ---------- reviews carousel ---------- */
  function initReviews(sec) {
    const track = sec.querySelector("[data-uc-rev-track]");
    if (!track || track.dataset.ready) return;
    track.dataset.ready = "1";
    const cardStep = () => (track.firstElementChild?.offsetWidth || 300) + 2;
    const atEnd = () => track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
    const go = dir => {
      if (dir > 0 && atEnd()) track.scrollTo({ left: 0, behavior: "smooth" });
      else track.scrollBy({ left: dir * cardStep(), behavior: "smooth" });
    };
    let pausedUntil = 0;
    const hold = () => { pausedUntil = Date.now() + 9000; };
    sec.querySelector("[data-uc-rev-next]")?.addEventListener("click", () => { go(1); hold(); });
    sec.querySelector("[data-uc-rev-prev]")?.addEventListener("click", () => { go(-1); hold(); });
    ["pointerenter", "pointerdown", "focusin", "wheel", "touchstart"].forEach(ev => track.addEventListener(ev, hold, { passive: true }));
    if (!reduce) setInterval(() => {
      if (Date.now() < pausedUntil || document.hidden) return;
      const r = track.getBoundingClientRect();
      if (r.bottom < 0 || r.top > innerHeight) return;
      go(1);
    }, 4800);
  }

  /* ---------- Boxy Blank product page ---------- */
  function initPdp(sec) {
    const dataEl = sec.querySelector("[data-uc-pdp-data]");
    if (!dataEl || sec.dataset.ready) return;
    sec.dataset.ready = "1";
    const D = JSON.parse(dataEl.textContent);
    const norm = s => String(s || "").trim().toLowerCase();
    const money = cents => {
      const v = cents / 100;
      return "$" + (Number.isInteger(v) ? v : v.toFixed(2));
    };
    // A color block matches a variant when the variant's color value is one of the block's names.
    const colorOf = v => D.colorIndex >= 0 ? norm(v.options[D.colorIndex]) : "";
    const sizeOf = v => D.sizeIndex >= 0 ? v.options[D.sizeIndex] : "";
    D.colors.forEach(c => { c.aliases = [c.name, ...(c.match || "").split(",")].map(norm).filter(Boolean); });
    const colors = D.colors.filter(c => D.variants.some(v => c.aliases.includes(colorOf(v))));
    if (!colors.length) return;
    const variantFor = (color, size) => D.variants.find(v => color.aliases.includes(colorOf(v)) && sizeOf(v) === size);

    const el = s => sec.querySelector(s);
    const sw = el("[data-uc-swatches]"), sizesEl = el("[data-uc-sizes]"), packsEl = el("[data-uc-packs]"), slotsEl = el("[data-uc-slots]");
    const addBtn = el("[data-uc-add-btn]"), msg = el("[data-uc-msg]"), colorName = el("[data-uc-color-name]");
    let color = colors[0], size = null, pack = 1, slotColors = [];

    sw.innerHTML = colors.map(c => `<button type="button" data-id="${c.id}" aria-label="${c.name}" aria-pressed="false">${c.tile ? `<img src="${c.tile}" alt="" loading="lazy">` : ""}</button>`).join("");
    sizesEl.innerHTML = D.sizes.map(s => `<button type="button" data-size="${s}" aria-pressed="false">${D.sizeLabels?.[s] || s}</button>`).join("");
    if (packsEl && colors.length < 4) packsEl.querySelector('[data-n="4"]')?.setAttribute("hidden", "");

    function show(id) {
      color = colors.find(c => c.id === id) || colors[0];
      for (const k of ["front", "back", "him", "her"]) {
        const img = sec.querySelector(`[data-uc-g="${k}"]`);
        if (!img) continue;
        const src = color[k];
        img.closest("figure").hidden = !src;
        if (src) { img.src = src; img.alt = img.dataset.alt.replace("{color}", color.name); }
      }
      sec.querySelectorAll("[data-uc-fit]").forEach(f => f.textContent = `Fit · ${color.name}`);
      if (colorName) colorName.textContent = color.name;
      sw.querySelectorAll("button").forEach(b => b.setAttribute("aria-pressed", String(b.dataset.id === color.id)));
      if (pack === 3) { slotColors = defaultSlots(3); renderSlots(); }
      updateSizes();
    }
    function updateSizes() {
      sizesEl.querySelectorAll("button").forEach(b => {
        const v = variantFor(color, b.dataset.size);
        if (!v || !v.available) b.setAttribute("data-soldout", ""); else b.removeAttribute("data-soldout");
      });
    }
    const defaultSlots = n => { const start = colors.indexOf(color); return Array.from({ length: n }, (_, k) => colors[(start + k) % colors.length].id); };
    function renderSlots() {
      if (pack === 1) { slotsEl.hidden = true; slotsEl.innerHTML = ""; return; }
      slotsEl.hidden = false;
      if (pack === 4) {
        slotColors = colors.map(c => c.id);
        slotsEl.innerHTML = `<div class="uc-slot-row">${colors.map(c => `<figure>${c.tile ? `<img src="${c.tile}" alt="">` : ""}<figcaption>${c.name}</figcaption></figure>`).join("")}</div>
          <p class="uc-pack-note">All four in one size. Pack pricing also applies when you add tees one at a time.</p>`;
        return;
      }
      slotsEl.innerHTML = slotColors.map((id, k) => {
        const c = colors.find(x => x.id === id);
        return `<label class="uc-slot">${c.tile ? `<img src="${c.tile}" alt="">` : "<span></span>"}
          <select data-slot="${k}" aria-label="Tee ${k + 1} color">${colors.map(o => `<option value="${o.id}"${o.id === id ? " selected" : ""}>Tee ${k + 1}: ${o.name}</option>`).join("")}</select></label>`;
      }).join("") + `<p class="uc-pack-note">One size for the pack. Need different sizes? Add tees one at a time and the pack price applies in your bag.</p>`;
    }
    function packTotal(n) { return n >= 4 ? D.pack4 * n : n >= 3 ? D.pack3 * n : D.price * n; }
    function updateAdd() {
      msg.textContent = "";
      if (!addBtn) return;   // before a drop the countdown stands in for the button
      if (!size) { addBtn.textContent = "Select a size"; return; }
      addBtn.textContent = pack === 1 ? `Add to bag · ${money(D.price)}` : `Add ${pack} to bag · ${money(packTotal(pack))}`;
    }
    function setPack(n) {
      if (!packsEl) return;
      pack = n;
      packsEl.querySelectorAll("button").forEach(b => b.setAttribute("aria-checked", String(+b.dataset.n === n)));
      if (n === 3) slotColors = defaultSlots(3);
      renderSlots(); updateAdd();
    }

    packsEl?.addEventListener("click", e => { const b = e.target.closest("button"); if (b) setPack(+b.dataset.n); });
    slotsEl?.addEventListener("change", e => { const s = e.target.closest("[data-slot]"); if (!s) return; slotColors[+s.dataset.slot] = s.value; renderSlots(); });
    sw.addEventListener("click", e => {
      const b = e.target.closest("button"); if (!b) return;
      history.replaceState(null, "", `${location.pathname}${location.search}#${b.dataset.id}`);
      show(b.dataset.id);
    });
    sizesEl.addEventListener("click", e => {
      const b = e.target.closest("button"); if (!b) return;
      size = b.dataset.size;
      sizesEl.querySelectorAll("button").forEach(x => x.setAttribute("aria-pressed", String(x === b)));
      updateAdd();
    });
    addBtn?.addEventListener("click", async () => {
      if (!size) { msg.textContent = "Choose a size."; return; }
      const ids = (pack === 1 ? [color.id] : slotColors).map(id => colors.find(c => c.id === id));
      const counts = new Map();
      for (const c of ids) {
        const v = variantFor(c, size);
        if (!v || !v.available) { msg.textContent = `${c.name} in ${size} is sold out.`; return; }
        counts.set(v.id, (counts.get(v.id) || 0) + 1);
      }
      addBtn.disabled = true;
      try { await addToCart([...counts].map(([id, quantity]) => ({ id, quantity }))); }
      catch (err) { msg.textContent = err.message; }
      finally { addBtn.disabled = false; }
    });

    // #charcoal picks a color, #pack3 / #pack4 a pack; ?variant= preselects color and size.
    const fromHash = () => {
      const id = location.hash.slice(1);
      if (colors.some(c => c.id === id)) show(id);
      if (id === "pack3" || id === "pack4") setPack(+id.slice(-1));
    };
    const pv = new URLSearchParams(location.search).get("variant");
    const v0 = pv && D.variants.find(v => String(v.id) === pv);
    const c0 = v0 && colors.find(c => c.aliases.includes(colorOf(v0)));
    show(c0 ? c0.id : (colors.some(c => c.id === location.hash.slice(1)) ? location.hash.slice(1) : colors[0].id));
    if (v0) sizesEl.querySelector(`[data-size="${CSS.escape(sizeOf(v0))}"]`)?.click();
    fromHash();
    addEventListener("hashchange", fromHash);
    updateAdd();
  }

  /* ---------- signup popup: email, then phone, then code (Klaviyo) ---------- */
  function initSignup() {
    const cfg = document.getElementById("uc-signup");
    if (!cfg || cfg.dataset.ready) return;
    cfg.dataset.ready = "1";
    const K = { key: cfg.dataset.key, list: cfg.dataset.list, revision: "2025-07-15", source: "Site popup: 20% off" };
    const CODE = cfg.dataset.code || "WELCOME20";
    const holder = document.createElement("div");
    holder.className = "uc";
    holder.style.background = "transparent";
    document.body.appendChild(holder);

    async function subscribe({ email, phone }) {
      if (!K.key || !K.list || !email) return false;
      const attributes = { email, subscriptions: { email: { marketing: { consent: "SUBSCRIBED" } } } };
      if (phone) { attributes.phone_number = phone; attributes.subscriptions.sms = { marketing: { consent: "SUBSCRIBED" } }; }
      try {
        const res = await fetch(`https://a.klaviyo.com/client/subscriptions?company_id=${encodeURIComponent(K.key)}`, {
          method: "POST",
          headers: { "Content-Type": "application/vnd.api+json", revision: K.revision },
          body: JSON.stringify({ data: { type: "subscription", attributes: { custom_source: K.source, profile: { data: { type: "profile", attributes } } },
            relationships: { list: { data: { type: "list", id: K.list } } } } }),
        });
        return res.ok;
      } catch { return false; }
    }
    const announce = open => document.dispatchEvent(new CustomEvent("uc:modal", { detail: open }));
    function open(step = 1, email = "") {
      announce(true);
      const esc = s => s.replace(/[&<>"]/g, ch => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[ch]));
      const bar = n => `<div class="uc-steps" aria-hidden="true">${[1, 2, 3].map(i => `<i class="${i <= n ? "on" : ""}"></i>`).join("")}</div>`;
      const views = {
        1: `${bar(1)}<p class="uc-lbl">Counter Culture Club</p>
            <h2>20% off your first order</h2>
            <p>Join for early access to every drop, starting with the Boxy Blank.</p>
            <form data-s1 class="uc-field" novalidate>
              <label for="ucEmail">Email</label>
              <input id="ucEmail" type="email" autocomplete="email" value="${esc(email)}">
              <span class="uc-err" data-e1></span>
              <button class="uc-btn" type="submit">Continue</button>
            </form>
            <button type="button" class="uc-skip" data-close>No thanks</button>`,
        2: `${bar(2)}<p class="uc-lbl">One more step</p>
            <h2>Get drop alerts by text</h2>
            <p>Add your mobile number to unlock your code.</p>
            <form data-s2 class="uc-field" novalidate>
              <label for="ucPhone">Mobile number</label>
              <div class="uc-phone-row"><input id="ucCC" value="+1" aria-label="Country code"><input id="ucPhone" type="tel" autocomplete="tel-national"></div>
              <span class="uc-err" data-e2></span>
              <button class="uc-btn" type="submit">Unlock 20% off</button>
              <p class="uc-consent">By submitting, you agree to receive recurring automated marketing texts from Uncertified at this number. Consent is not a condition of purchase. Msg and data rates may apply. Msg frequency varies. Reply STOP to cancel, HELP for help. See our <a href="${cfg.dataset.terms || "/policies/terms-of-service"}">Terms</a> and <a href="${cfg.dataset.privacy || "/policies/privacy-policy"}">Privacy Policy</a>.</p>
            </form>
            <button type="button" class="uc-skip" data-step3>Skip, send my code by email</button>`,
        3: `${bar(3)}<p class="uc-lbl">You're in</p>
            <h2>Welcome to the club</h2>
            <p>Use this code at checkout for 20% off your first order. We also sent it to ${email ? esc(email) : "your inbox"}.</p>
            <div class="uc-code"><code data-code>${CODE}</code><button type="button" class="uc-btn" data-copy>Copy</button></div>
            <a class="uc-link" href="${cfg.dataset.shop || "/"}" data-close style="justify-self:start">Shop the Blanks</a>`,
      };
      holder.innerHTML = `<div class="uc-modal-back" data-back><div class="uc-modal" role="dialog" aria-modal="true" aria-label="Sign up for 20% off">
        <button type="button" class="uc-x" aria-label="Close" data-close>×</button>
        <figure>${cfg.dataset.image ? `<img src="${cfg.dataset.image}" alt="">` : ""}</figure>
        <div class="uc-modal__body">${views[step]}</div></div></div>`;
      const s1 = holder.querySelector("[data-s1]"), s2 = holder.querySelector("[data-s2]");
      if (s1) {
        holder.querySelector("#ucEmail").focus();
        s1.addEventListener("submit", e => {
          e.preventDefault();
          const v = holder.querySelector("#ucEmail").value.trim();
          if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v)) { holder.querySelector("[data-e1]").textContent = "Enter a valid email address."; return; }
          subscribe({ email: v });   // keep the email even if they stop at the phone step
          open(2, v);
        });
      }
      if (s2) {
        holder.querySelector("#ucPhone").focus();
        s2.addEventListener("submit", e => {
          e.preventDefault();
          const digits = holder.querySelector("#ucPhone").value.replace(/\D/g, "");
          if (digits.length < 10) { holder.querySelector("[data-e2]").textContent = "Enter a 10-digit mobile number."; return; }
          const cc = holder.querySelector("#ucCC").value.replace(/[^\d+]/g, "") || "+1";
          subscribe({ email, phone: `${cc.startsWith("+") ? cc : `+${cc}`}${digits.slice(-10)}` });
          open(3, email);
        });
      }
      holder.querySelector("[data-step3]")?.addEventListener("click", () => open(3, email));
      const copy = holder.querySelector("[data-copy]");
      if (copy) copy.addEventListener("click", () => {
        const select = () => { const r = document.createRange(); r.selectNodeContents(holder.querySelector("[data-code]")); getSelection().removeAllRanges(); getSelection().addRange(r); };
        try { navigator.clipboard.writeText(CODE).then(() => { copy.textContent = "Copied"; }, select); } catch { select(); }
      });
      try { localStorage.setItem("uc_offer_seen", String(Date.now())); } catch {}
    }
    function close() {
      if (!holder.innerHTML) return;
      holder.innerHTML = "";
      announce(false);
    }
    holder.addEventListener("click", e => { if (e.target.matches("[data-back]") || e.target.closest("[data-close]")) close(); });
    document.addEventListener("keydown", e => { if (e.key === "Escape") close(); });
    document.addEventListener("click", e => { if (e.target.closest("[data-uc-open-offer]")) { e.preventDefault(); open(1); } });

    if (cfg.dataset.tab !== "false") {
      const tab = document.createElement("button");
      tab.type = "button";
      tab.className = "uc-offer-tab";
      tab.setAttribute("data-uc-open-offer", "");
      tab.textContent = "20% off";
      document.body.appendChild(tab);
    }
    // Show once per visitor per week, after they've had time to look around. Never in the theme editor.
    let seenAt = 0; try { seenAt = +localStorage.getItem("uc_offer_seen") || 0; } catch {}
    const delay = (+cfg.dataset.delay || 12) * 1000;
    if (!window.Shopify?.designMode && Date.now() - seenAt > 7 * 864e5) setTimeout(() => { if (!holder.innerHTML) open(1); }, delay);
  }

  /* ---------- drop countdown ---------- */
  // Every [data-uc-countdown] ticks down to its data-launch (ms). The server decides when the drop is live
  // (the page is rendered locked until then), so at zero a locked page asks again with a fresh URL that no
  // cache can answer, retrying every 15 s until the server agrees.
  let countdownStarted = false;
  function initCountdowns() {
    const els = [...document.querySelectorAll("[data-uc-countdown]")];
    const url = new URL(location.href);
    if (!document.querySelector("[data-uc-locked]") && url.searchParams.has("drop")) {
      url.searchParams.delete("drop");
      history.replaceState(null, "", url.pathname + url.search + url.hash);
    }
    if (!els.length || countdownStarted) return;
    countdownStarted = true;
    const launch = Math.min(...els.map(e => +e.dataset.launch || Infinity));
    const pad = n => String(n).padStart(2, "0");
    const fmt = ms => {
      const s = Math.floor(ms / 1000);
      const d = Math.floor(s / 86400), h = Math.floor((s % 86400) / 3600), m = Math.floor((s % 3600) / 60);
      return (d ? `${d}d ` : "") + `${pad(h)}h ${pad(m)}m ${pad(s % 60)}s`;
    };
    let timer = null;
    const tick = () => {
      const left = launch - Date.now();
      els.forEach(el => { el.textContent = left > 0 ? fmt(left) : "Dropping now"; });
      if (left > 0) return;
      clearInterval(timer);
      if (!document.querySelector("[data-uc-locked]")) return;
      const again = url.searchParams.has("drop");
      if (again && left < -10 * 60 * 1000) return;   // this device's clock is far ahead of the server's: stop asking
      url.searchParams.set("drop", Date.now().toString(36));
      setTimeout(() => location.replace(url.toString()), again ? 15000 : 600 + Math.random() * 2400);
    };
    timer = setInterval(tick, 1000);
    tick();
  }

  function initAll(scope = document) {
    scope.querySelectorAll("[data-uc-ring]").forEach(initRing);
    scope.querySelectorAll("[data-uc-reviews]").forEach(initReviews);
    scope.querySelectorAll("[data-uc-pdp]").forEach(initPdp);
    initSignup();
    initCountdowns();
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", () => initAll());
  else initAll();
  // Re-run when a section is edited in the theme editor.
  document.addEventListener("shopify:section:load", e => initAll(e.target));

  window.UC = { addToCart, toast };
})();
